import {Product} from './product';

export class ProductCategory {
    constructor() {
    }

    _id?: string;
    name: string;
    status: number;
    products: Array<Product>;
    createdAt: string;
    updatedAt: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/productCategory.ts